import {useTranslation} from "react-i18next";
import {TableColumnConfig} from "../../../../../../../../../models/interfaces";
import TableHeaderCell from "../../../../../../../../../components/layout/table/TableHeaderCell";
import TableNoRecords from "../../../../../../../../../components/layout/table/TableNoRecords";
import React from "react";
import {TakeoffTemplateGroup} from "../../../../../../../../../models/TakeoffTemplateGroup";

type GroupsTableProps = {
	items: TakeoffTemplateGroup[],
	onItemClick: (checkedGroup: TakeoffTemplateGroup) => void
}

export function GroupsTable({items, onItemClick}: GroupsTableProps) {
	const {t} = useTranslation();

	const columns: TableColumnConfig<TakeoffTemplateGroup>[] = [
		{
			id: "name",
			label: t("projects.addItemModal.takeoffTemplates.groupName"),
			sortable: false
		}
	];

	return (
		<div className="material-modal_container_content_table-container groups">
			<table className="table">
				<thead>
				<tr>
					{columns.map(
						col => <TableHeaderCell<TakeoffTemplateGroup> key={col.id}
																	  id={col.id}
																	  label={col.label}
																	  width={col.width}/>)}
				</tr>
				</thead>
				<tbody>
				{items.length ?
					items.map(item =>
						<tr key={item.id} onClick={() => onItemClick(item)}>
							<td className="link">{item.name}</td>
						</tr>)
					: <TableNoRecords cols={columns.length}/>}
				</tbody>
			</table>
		</div>

	);
}